export const SET_PREOWNED_RATES = 'SET_PREOWNED_RATES';
export const SET_IS_PREOWNED_RATES_UPDATED = ' SET_IS_PREOWNED_RATES_UPDATED';
export const UPDATED_PREWOWNED_RATES = 'UPDATED_PREWOWNED_RATES';
export const SET_PREWOWNED_RATES_FILTER = 'SET_PREWOWNED_RATES_FILTER';
export const UPDATED_PREWOWNED_RATES_FILTER = 'UPDATED_PREWOWNED_RATES_FILTER';
